import React from 'react'
import { Element } from 'slate'
import { makeStyles } from '@cicero/ui'
import { IEditorElementProps, IEditorLeafProps, IElementDefinition } from '../EditorService'
import { IParagraphElement, IParagraphTextLeaf } from '../commands'

export const ElementBlock = ({ children, attributes }: { children: JSX.Element|JSX.Element[], attributes: any }) => {
  const { paragraphWrapper } = useEditorBlockStyles()
  return <div {...attributes} className={paragraphWrapper} >
    {/* <span contentEditable={false} className={cn(paragraphBlockHandle, 'visible-on-hover')}>
      <Icon>drag_handle</Icon>
    </span> */}
    { children }
  </div>
}

export const ParagraphElement = ({ children, attributes }: IEditorElementProps<IParagraphElement>) => {
  return <ElementBlock attributes={attributes}>{children}</ElementBlock>
}

export const ParagraphLeaf = ({ children, attributes, text }: IEditorLeafProps<IParagraphTextLeaf>) => {
  const { bold, italic, underline, ...restOfStyles } = useParagraphLeafStyles()
  const classes = []

  // TODO Memoize this
  if (text.bold) { classes.push(bold) }
  if (text.italic) { classes.push(italic) }
  if (text.underline) { classes.push(underline) }
  if (text.level) { classes.push((restOfStyles as any)[text.level]) }

  return <span {...attributes} className={classes.join(' ')}>{children}</span>
}

export const ParagraphElementDef: IElementDefinition = {
  renderer(props) { return <ParagraphElement {...props} /> },
}

export const useEditorBlockStyles = makeStyles({
  paragraphWrapper: {
    background: '#FFF',
    boxSizing: 'border-box',
    display: 'block',
    padding: '12px 32px',
    margin: '0 6px',
    boxShadow: '0px 0px 0px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12)',

    '&:first-of-type': {
      marginTop: 16,
      paddingTop: 32,
      boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12)',
    },

    '&:last-of-type': {
      marginBottom: 16,
      paddingBottom: 32,
    },
  },
  paragraphBlockHandle: {
    color: '#DDD',
    marginLeft: -52,
    transition: 'all ease-in-out 1s',
  },
})

const useParagraphLeafStyles = makeStyles({
  bold: {
    fontWeight: 'bold',
  },
  italic: {
    fontStyle: 'italic',
  },
  underline: {
    textDecoration: 'underline',
  },
  h1: {
    fontSize: 32,
    display: 'block',
    borderBottom: '1px solid #999',
  },
  h2: {
    fontSize: 26,
    display: 'block',
  },
  h3: {
    fontSize: 20,
    display: 'block',
  },
})
